module.exports = __webpack_public_path__ + "static/devops-f6954b1b807311621c3277e1169f542d.png";